const DEFAULT_WIDTHS = [480, 800, 1200, 1600]

const hasAbsoluteUrl = value =>
  typeof value === "string" &&
  (value.startsWith("http://") || value.startsWith("https://"))

const normaliseFormat = format => {
  if (format === "jpg") {
    return "pjpg"
  }

  return format
}

export const buildPrismicImageUrl = (url, params = {}) => {
  if (!hasAbsoluteUrl(url)) {
    return ""
  }

  const parsedUrl = new URL(url)

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return
    }

    parsedUrl.searchParams.set(key, value)
  })

  return parsedUrl.toString()
}

export const buildPrismicImageSrcSet = (
  url,
  widths = DEFAULT_WIDTHS,
  params = {}
) => {
  if (!hasAbsoluteUrl(url)) {
    return ""
  }

  return widths
    .map(width => {
      const src = buildPrismicImageUrl(url, { ...params, w: width })

      return `${src} ${width}w`
    })
    .join(", ")
}

export const getPrismicImageProps = (
  image,
  {
    widths = DEFAULT_WIDTHS,
    imgixParams = { auto: "compress,format", fit: "max" },
    sizes = "100vw",
  } = {}
) => {
  const url = image?.url

  if (!hasAbsoluteUrl(url)) {
    return {
      alt: image?.alt || "",
      sizes,
      src: "",
      srcSet: "",
    }
  }

  const srcSet = buildPrismicImageSrcSet(url, widths, imgixParams)
  const fallbackWidth = widths[Math.floor(widths.length / 2)] || widths[0]
  const src = buildPrismicImageUrl(url, {
    ...imgixParams,
    fm: normaliseFormat(imgixParams.fm),
    w: fallbackWidth,
  })

  return {
    alt: image?.alt || "",
    sizes,
    src,
    srcSet,
  }
}
